import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#1A1A1A] group-[.toaster]:border-[#1E5F6E]/15 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-[#5A5A5A]",
          actionButton:
            "group-[.toast]:bg-[#1E5F6E] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#FAF7F2] group-[.toast]:text-[#5A5A5A]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
